import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import moment from 'moment-timezone';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { Duration } from 'ziphy-web-shared/basic/lib/functional';
import { $router } from 'ziphy-web-shared/basic/utils/router';
import styles from './ActivityReminder.module.scss';
const ActivityReminder = ({ reminder }) => {
    const localTZ = moment.tz.guess();
    const startMoment = moment.tz(reminder.start, localTZ);
    const now = moment.tz(localTZ);
    if (startMoment.isBefore(now))
        return null;
    const handleOpen = () => {
        $router.history.push(`/appointments/${reminder.id}`);
    };
    return (_jsxs("div", Object.assign({ className: styles.reminder }, { children: [_jsxs("div", Object.assign({ className: styles.title }, { children: [_jsxs("div", Object.assign({ className: styles.titleTop }, { children: [_jsx("span", Object.assign({ style: { marginRight: 5 } }, { children: '\u23F0' })), _jsx("span", Object.assign({ className: 'mr-1' }, { children: "Telehealth Appointment Starts In" })), _jsx(Duration, { from: startMoment })] })), _jsx("div", { children: reminder.programName })] })), _jsx("div", Object.assign({ className: styles.button }, { children: _jsx(Button, Object.assign({ type: "nav", mode: ['xs', 'dark-blue'], onClick: handleOpen }, { children: "Open Visit" })) }))] })));
};
export default observer(ActivityReminder);
